import type { SVGProps } from "react";
const SenecPictogramEnFluRi = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.0001 12C11.0001 10.3431 12.3432 9 14.0001 9H34.0001C35.6569 9 37.0001 10.3431 37.0001 12V36C37.0001 37.6569 35.6569 39 34.0001 39H14.0001C12.3432 39 11.0001 37.6569 11.0001 36V30C11.0001 29.4477 11.4478 29 12.0001 29C12.5524 29 13.0001 29.4477 13.0001 30V32L35.0001 32V16L13.0001 16V25.5C13.0001 26.0523 12.5524 26.5 12.0001 26.5C11.4478 26.5 11.0001 26.0523 11.0001 25.5V12ZM13.0001 14L35.0001 14V12C35.0001 11.4477 34.5524 11 34.0001 11H14.0001C13.4478 11 13.0001 11.4477 13.0001 12V14ZM13.0001 34L35.0001 34V36C35.0001 36.5523 34.5524 37 34.0001 37H14.0001C13.4478 37 13.0001 36.5523 13.0001 36V34Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.0001 19H32.0001V29H16.0001V19ZM18.0001 21V27H30.0001V21H18.0001Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M40.0001 22.4142L38.7072 23.7071L37.293 22.2929L41.0001 18.5858L44.7072 22.2929L43.293 23.7071L42.0001 22.4142V28C42.0001 28.5523 41.5524 29 41.0001 29C40.4478 29 40.0001 28.5523 40.0001 28V22.4142Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.00008 25.5858L4.70718 24.2929L3.29297 25.7071L7.00008 29.4142L10.7072 25.7071L9.29297 24.2929L8.00007 25.5858V20C8.00007 19.4477 7.55236 19 7.00007 19C6.44779 19 6.00008 19.4477 6.00008 20L6.00008 25.5858Z"
            fill="currentColor"
        />
    </svg>
);
export default SenecPictogramEnFluRi;
